var map = {
	"./number_0.png": "0293",
	"./number_1.png": "8489",
	"./number_2.png": "db3d",
	"./number_3.png": "33ce",
	"./number_4.png": "c49a",
	"./number_5.png": "9357",
	"./number_6.png": "402a",
	"./number_7.png": "2e15",
	"./number_8.png": "55da",
	"./number_9.png": "e703"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "06b0";